import React, { useState } from "react";
import { TurnrCard, TurnrCardContent } from "./TurnrCard.jsx";
import OpenCloseChevronIcon from "../icons/OpenCloseChevronIcon.jsx";
import styles from "./CollapsibleTurnrCard.module.scss";
import classNames from "classnames";
import CollapsibleContent from "rylak-common/src/components/collapsible/CollapsibleContent.jsx";

export default function CollapsibleTurnrCard(props) {
    let { children, HeaderPart, headerPartProps, rest } = props;

    const [open, setOpen] = useState(false);

    return (
        <TurnrCard style={{ borderRadius: 0 }} className={classNames(styles["card"], open && styles["card-open"])} {...rest}>
            <div
                className={styles["header-part-wrapper"]}
                onClick={() => {
                    setOpen(!open);
                }}
            >
                {HeaderPart && <HeaderPart {...headerPartProps} open={open} chevronElement={<OpenCloseChevronIcon open={open} />} />}
            </div>
            <CollapsibleContent isOpen={open}>
                <TurnrCardContent>{children}</TurnrCardContent>
            </CollapsibleContent>
        </TurnrCard>
    );
}
